import React, { useState } from "react";
import abedalslam from "../../Images/abedalslam.png";
import waze from "../../Images/waze.png";
import call from "../../Images/call.png";
import whatsapp from "../../Images/whatsapp.png";
import { useAppContext } from "../../AppContext";
import { useParams } from "react-router-dom";

export default function MPHomeFirstBlock() {
  const { AllData, WazeData } = useAppContext();
  const { BarberPhoneNumber } = useParams();
  const screenHeight = window.screen.height;
  const [hoveredButton, setHoveredButton] = useState(null);
  const [shareHovered, setShareHovered] = useState(false);

  const handleWaze = () => {
    const lat = WazeData?.lat;
    const lng = WazeData?.long;

    if (!lat || !lng) {
      alert("Location not available");
      return;
    }
    const url = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
    window.location.href = url;
  };

  const handleCall = () => {
    window.location.href = `tel:${AllData.barberData.countryNumber}${AllData.barberData.phoneNumber}`;
  };

  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/${AllData.barberData.countryNumber}${AllData.barberData.phoneNumber}`,
      "_blank",
    );
  };

  const handleShare = async () => {
    const shareUrl = window.location.href;

    // Check if the browser supports the Web Share API
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${AllData.barberData.name}'s Profile`,
          text: `Check out ${AllData.barberData.name}'s barbershop`,
          url: shareUrl,
        });
      } catch (err) {
        // User cancelled or error occurred
        if (err.name !== "AbortError") {
          fallbackShare(shareUrl);
        }
      }
    } else {
      fallbackShare(shareUrl);
    }
  };

  const fallbackShare = (url) => {
    // Fallback: copy to clipboard
    navigator.clipboard.writeText(url).then(
      () => {
        alert("Link copied to clipboard!");
      },
      () => {
        alert("Failed to copy link");
      },
    );
  };

  const styles = {
    container: {
      position: "relative",
      display: "flex",
      width: "100%",
      minHeight: screenHeight / 2.8,
      alignItems: "center",
      justifyContent: "center",
      borderBottomLeftRadius: "32px",
      borderBottomRightRadius: "32px",
      flexDirection: "column",
      overflow: "hidden",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
      paddingBottom: "50px",
      paddingTop: "30px",
    },
    shareButton: {
      position: "absolute",
      top: "20px",
      left: "20px",
      zIndex: 2,
      width: "48px",
      height: "48px",
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      border: "none",
      borderRadius: "16px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      boxShadow: shareHovered
        ? "0 8px 24px rgba(0,0,0,0.25)"
        : "0 4px 12px rgba(0,0,0,0.15)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      transform: shareHovered ? "scale(1.1)" : "scale(1)",
    },
    shareIcon: {
      width: "24px",
      height: "24px",
      fill: "#667eea",
    },
    backgroundOverlay: {
      position: "absolute",
      inset: 0,
      background:
        "radial-gradient(circle at 30% 50%, rgba(255,255,255,0.15) 0%, transparent 60%)",
      zIndex: 0,
    },
    backgroundPattern: {
      position: "absolute",
      inset: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      zIndex: 0,
      opacity: 0.4,
    },
    contentWrapper: {
      position: "relative",
      zIndex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "24px",
      padding: "0 20px",
      maxWidth: "600px",
      width: "100%",
    },
    imageContainer: {
      position: "relative",
      padding: "5px",
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
      borderRadius: "28px",
      boxShadow:
        "0 12px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,255,255,0.3)",
      transition: "transform 0.3s ease",
    },
    profileImage: {
      width: "140px",
      height: "140px",
      borderRadius: "24px",
      objectFit: "cover",
      display: "block",
      border: "3px solid rgba(255,255,255,0.5)",
    },
    placeholderAvatar: {
      width: "140px",
      height: "140px",
      borderRadius: "24px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "56px",
      fontWeight: "700",
      color: "#fff",
      background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      border: "3px solid rgba(255,255,255,0.5)",
      textShadow: "0 2px 8px rgba(0,0,0,0.2)",
      userSelect: "none",
    },
    textContainer: {
      textAlign: "center",
      color: "#fff",
    },
    name: {
      fontSize: "28px",
      fontWeight: "700",
      margin: "0 0 8px 0",
      textShadow: "0 2px 8px rgba(0,0,0,0.3)",
      letterSpacing: "-0.02em",
      lineHeight: "1.2",
    },
    phone: {
      fontSize: "16px",
      margin: 0,
      opacity: 0.95,
      fontWeight: "500",
      textShadow: "0 1px 4px rgba(0,0,0,0.2)",
      letterSpacing: "0.02em",
    },
    buttonsContainer: {
      display: "flex",
      gap: "20px",
      flexWrap: "wrap",
      justifyContent: "center",
    },
    actionButton: (isHovered) => ({
      width: "64px",
      height: "64px",
      backgroundColor: "#fff",
      border: "none",
      borderRadius: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      boxShadow: isHovered
        ? "0 8px 24px rgba(0,0,0,0.25)"
        : "0 6px 16px rgba(0,0,0,0.15)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      transform: isHovered
        ? "translateY(-4px) scale(1.05)"
        : "translateY(0) scale(1)",
      position: "relative",
      overflow: "hidden",
    }),
    buttonIcon: {
      width: "36px",
      height: "36px",
      position: "relative",
      zIndex: 1,
      transition: "transform 0.3s ease",
    },
    buttonRipple: {
      position: "absolute",
      inset: 0,
      background:
        "radial-gradient(circle, rgba(0,0,0,0.05) 0%, transparent 70%)",
      opacity: 0,
      transition: "opacity 0.3s ease",
    },
  };

  const actions = [
    {
      icon: waze,
      onClick: handleWaze,
      label: "Navigate",
      color: "#00D9FF",
    },
    {
      icon: call,
      onClick: handleCall,
      label: "Call",
      color: "#4CAF50",
    },
    {
      icon: whatsapp,
      onClick: handleWhatsApp,
      label: "WhatsApp",
      color: "#25D366",
    },
  ];

  // Get first letter of name for placeholder
  const getInitial = () => {
    return AllData.barberData.name?.charAt(0).toUpperCase() || "B";
  };

  return (
    <>
      <style>
        {`
          @keyframes float {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
          }

          .image-container:hover {
            transform: scale(1.05);
          }

          .action-button:active {
            transform: translateY(-2px) scale(0.98) !important;
          }

          .share-button:active {
            transform: scale(0.95) !important;
          }

          @media (max-width: 768px) {
            .name {
              font-size: 24px !important;
            }
            
            .phone {
              font-size: 14px !important;
            }
            
            .profile-image {
              width: 120px !important;
              height: 120px !important;
            }

            .placeholder-avatar {
              width: 120px !important;
              height: 120px !important;
              font-size: 48px !important;
            }
            
            .action-button {
              width: 56px !important;
              height: 56px !important;
            }
            
            .button-icon {
              width: 32px !important;
              height: 32px !important;
            }

            .share-button {
              width: 44px !important;
              height: 44px !important;
              top: 16px !important;
              left: 16px !important;
            }
          }

          @media (max-width: 480px) {
            .name {
              font-size: 22px !important;
            }
            
            .buttons-container {
              gap: 16px !important;
            }

            .placeholder-avatar {
              width: 120px !important;
              height: 120px !important;
              font-size: 44px !important;
            }

            .share-button {
              width: 40px !important;
              height: 40px !important;
              top: 12px !important;
              left: 12px !important;
            }
          }
        `}
      </style>

      <div style={styles.container}>
        {/* Share Button */}
        <button
          onClick={handleShare}
          style={styles.shareButton}
          className="share-button"
          onMouseEnter={() => setShareHovered(true)}
          onMouseLeave={() => setShareHovered(false)}
          aria-label="Share"
        >
          <svg
            style={styles.shareIcon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
          </svg>
        </button>

        {/* Background Overlays */}
        <div style={styles.backgroundOverlay} />
        <div style={styles.backgroundPattern} />

        {/* Content */}
        <div style={styles.contentWrapper}>
          {/* Profile Image */}
          <div style={styles.imageContainer} className="image-container">
            {AllData.barberData.image ? (
              <img
                src={AllData.barberData.image}
                alt="Barber Profile"
                style={styles.profileImage}
                className="profile-image"
              />
            ) : (
              <div
                style={styles.placeholderAvatar}
                className="placeholder-avatar"
              >
                {getInitial()}
              </div>
            )}
          </div>

          {/* Text Information */}
          <div style={styles.textContainer}>
            <h1 style={styles.name} className="name">
              {AllData.barberData.name}
            </h1>
          </div>

          {/* Action Buttons */}
          <div style={styles.buttonsContainer} className="buttons-container">
            {actions.map((action, index) => (
              <button
                key={index}
                onClick={action.onClick}
                style={styles.actionButton(hoveredButton === index)}
                className="action-button"
                onMouseEnter={() => setHoveredButton(index)}
                onMouseLeave={() => setHoveredButton(null)}
                aria-label={action.label}
              >
                <div
                  style={{
                    ...styles.buttonRipple,
                    opacity: hoveredButton === index ? 1 : 0,
                  }}
                />
                <img
                  src={action.icon}
                  alt={action.label}
                  style={styles.buttonIcon}
                  className="button-icon"
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
